import React, { Component } from "react";
import styles from "./Steps.scss";
import classnames from "classnames";
import { Link } from "react-router-dom";

import { Mixpanel } from "../../../actions/mixpanel.actions";
import separator from "../../../assets/images/step-separator.svg";

class Steps extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { steps, activeStep } = this.props;

    return (
      <div className={styles.steps}>
        {steps &&
          steps.map((step, index) => {
            return (
              <div className={styles.step} key={`steps_${index}`}>
                {index < activeStep ? (
                  <Link
                    id={`step-${step.caption.toLowerCase()}`}
                    to={step.url || "#"}
                    onClick={() =>
                      Mixpanel.track(`Project - Steps - ${step.caption}`)
                    }
                  >
                    <div
                      className={classnames(styles.caption, {
                        [styles.isactive]: index === activeStep,
                        [styles.isinactive]: index !== activeStep
                      })}
                    >
                      {step.caption}
                    </div>
                  </Link>
                ) : (
                  <div
                    className={classnames(styles.caption, {
                      [styles.isactive]: index === activeStep,
                      [styles.isinactive]: index !== activeStep
                    })}
                  >
                    {step.caption}
                  </div>
                )}

                {index < steps.length - 1 && (
                  <img src={separator} className={styles.separator} />
                )}
              </div>
            );
          })}
      </div>
    );
  }
}

export default Steps;



// WEBPACK FOOTER //
// ./src/components/common/steps/Steps.js